// Floating Reviews Tab - Customer Reviews Screenshots

(function() {
  'use strict';
  
  // إعدادات
  const CONFIG = {
    tabText: 'Reviews',
    position: 'right',
  };
  
  // صور المراجعات
  const REVIEW_IMAGES = [
    {
      id: 1,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.12_PM_3.jpg?v=1763991142',
      alt: 'مراجعة عميل 1'
    },
    {
      id: 2,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.12_PM.jpg?v=1763991142',
      alt: 'مراجعة عميل 2'
    },
    {
      id: 3,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.12_PM_4.jpg?v=1763991142',
      alt: 'مراجعة عميل 3'
    },
    {
      id: 4,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.13_PM_1.jpg?v=1763991142',
      alt: 'مراجعة عميل 4'
    },
    {
      id: 5,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.12_PM_5.jpg?v=1763991142',
      alt: 'مراجعة عميل 5'
    },
    {
      id: 6,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.12_PM_1.jpg?v=1763991142',
      alt: 'مراجعة عميل 6'
    },
    {
      id: 7,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.12_PM_2.jpg?v=1763991142',
      alt: 'مراجعة عميل 7'
    },
    {
      id: 8,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0785/9942/2181/files/WhatsApp_Image_2025-11-24_at_3.12.13_PM.jpg?v=1763991142',
      alt: 'مراجعة عميل 8'
    }
  ];
  
  // إنشاء HTML للزرار الجانبي
  function createFloatingTab() {
    const button = document.createElement('button');
    button.className = 'floating-reviews-tab';
    button.innerHTML = `
      ${CONFIG.tabText}
      <span class="rating">★★★★★</span>
    `;
    button.addEventListener('click', openReviewsPopup);
    return button;
  }
  
  // إنشاء HTML للنافذة المنبثقة
  function createPopup() {
    const overlay = document.createElement('div');
    overlay.className = 'reviews-popup-overlay';
    overlay.innerHTML = `
      <div class="reviews-popup">
        <div class="reviews-popup-header">
         <button class="reviews-popup-close" aria-label="Close">&times;</button>
         <h2>Customer Reviews </h2> 
        </div>
        <div class="reviews-popup-content">
          ${createReviewImagesHTML()}
        </div>
      </div>
    `;
    
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.classList.contains('reviews-popup-close')) {
        closeReviewsPopup();
      }
    });
    
    return overlay;
  }
  
  // إنشاء HTML لعرض الصور
  function createReviewImagesHTML() {
    if (REVIEW_IMAGES.length === 0) {
      return `
        <div class="no-reviews">
          <h3>لا توجد مراجعات بعد</h3>
          <p>كن أول من يشارك رأيه في منتجاتنا!</p>
        </div>
      `;
    }
    
    return `
      <div class="reviews-images-grid">
        ${REVIEW_IMAGES.map(review => `
          <div class="review-image-wrapper">
            <img 
              src="${review.imageUrl}" 
              alt="${review.alt}"
              class="review-image"
              loading="lazy"
            />
          </div>
        `).join('')}
      </div>
    `;
  }
  
  // فتح النافذة المنبثقة
  function openReviewsPopup() {
    const overlay = document.querySelector('.reviews-popup-overlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  
  // إغلاق النافذة المنبثقة
  function closeReviewsPopup() {
    const overlay = document.querySelector('.reviews-popup-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  
  // تهيئة الـ Widget
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    // إضافة الزرار الجانبي
    const floatingTab = createFloatingTab();
    document.body.appendChild(floatingTab);
    
    // إضافة النافذة المنبثقة
    const popup = createPopup();
    document.body.appendChild(popup);
    
    // إغلاق بزر Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeReviewsPopup();
      }
    });
  }
  
  // بدء التنفيذ
  init();
})();